import ServiceLocator from "../ServiceLocator";
import * as PIXI from "pixi.js";

import Card from "./game/Card";
import { Signal } from "signals";
import { IGameLayers } from "./GameplayScreen";


export default abstract class Input 
{
    protected _layers: IGameLayers = null;

    protected _baseCardY: number = null;

    protected _selCard: Card = null;

    protected _isEnabled: boolean = null;

    protected _onCardSelected: Signal = null;


    public set layers( value: IGameLayers ) { this._layers = value; }

    public get selCard(): Card { return this._selCard; }

    public get onCardSelected(): Signal { return this._onCardSelected; }


    protected constructor() {}

    public abstract init(): void;
    public abstract end(): void;

    public abstract clearSelectedCard(): void;

    public abstract setEnabled( isEnabled: boolean ): void;
}